

























































































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import {
  IConditionalExpressionContent,
  IConditionalExpressionObjectReference,
  ExpressionOperatorKinds,
  ExpressionLogicalOperatorKinds,
  ExpressionReferenceKinds,
} from "../../../../../../../documaker/domain/format/objects";
import { ConditionalExpressionObjectSelector, ConditionalExpressionContentSelector } from "../selectors";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";

@Component({
  components: {
    ConditionalExpressionObjectSelector,
    ConditionalExpressionContentSelector,
  }
})
export default class ConditionalExpressionContentEditDialog extends Mixins(DialogMixin) {
  contents: IConditionalExpressionContent[] = [];
  selectionObjects: IFormatObjectEditable[] = [];

  selectedContents: IConditionalExpressionContent[] = [];
  selectedSourceObject: IFormatObjectEditable = null;
  selectedValueObject: IFormatObjectEditable = null;
  fixedValue: string = "";

  confirmed: boolean = false;

  get hasSelectedObjects(): boolean {
    return !!this.selectedSourceObject && !!this.selectedValueObject;
  }

  get hasFixedValue(): boolean {
    return !!this.selectedSourceObject;
  }

  get hasSelectedContents(): boolean {
    return this.selectedContents.length > 0;
  }

  get isTopSelectedContent(): boolean {
    return this.hasSelectedContents && this.selectedContents.some(v => v === this.contents[0]);
  }

  get isBottomSelectedContent(): boolean {
    return this.hasSelectedContents && this.selectedContents.some(v => v === this.contents[this.contents.length - 1]);
  }

  async show(contents: IConditionalExpressionContent[], selectionObjects: IFormatObjectEditable[]): Promise<IConditionalExpressionContent[]> {
    return this.showModal(async () => {
      this.contents = ObjectUtility.copyDeeply(contents);
      this.selectionObjects = selectionObjects;

      this.selectedContents = [];
      this.selectedSourceObject = null;
      this.selectedValueObject = null;
      this.fixedValue = "";

      this.confirmed = false;
      await this.waitHidden();
      const ret = this.confirmed ? this.contents : null;
      this.contents = [];
      this.selectionObjects = [];
      return ret;
    });
  }

  changeSourceObject(currentRow: IFormatObjectEditable, oldCurrentRow: IFormatObjectEditable) {
    this.selectedSourceObject = currentRow;
  }

  changeValueObject(currentRow: IFormatObjectEditable, oldCurrentRow: IFormatObjectEditable) {
    this.selectedValueObject = currentRow;
  }

  addSelectedObject() {
    this.contents = this.contents.concat({
      reference: this.selectedSourceObject.toLinkedObjectIdentifier(),
      operator: ExpressionOperatorKinds.LessThan,
      value: "",
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      logicalOperator: ExpressionLogicalOperatorKinds.None,
      presentation: {
        kind: ExpressionReferenceKinds.Object,
        reference: this.selectedValueObject.toLinkedObjectIdentifier(),
      },
    });
  }

  addFixedValue() {
    this.contents = this.contents.concat({
      reference: this.selectedSourceObject.toLinkedObjectIdentifier(),
      operator: ExpressionOperatorKinds.LessThan,
      value: "",
      brackets: {
        openCount: 0,
        closeCount: 0,
      },
      logicalOperator: ExpressionLogicalOperatorKinds.None,
      presentation: {
        kind: ExpressionReferenceKinds.Fixed,
        reference: this.fixedValue,
      },
    });
  }

  moveContents(offset: number) {
    const indexes = this.selectedContents.map(v => this.contents.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveContent(i, offset));
  }

  private moveContent(index: number, offset: number) {
    const item = this.contents[index];
    this.contents.splice(index, 1);
    this.contents.splice(index + offset, 0, item);
  }

  removeContents() {
    this.contents = this.contents.filter((v) => !this.selectedContents.some(s => s === v));
  }

  toSourceTypeName(row: IConditionalExpressionContent): string {
    return this.toTypeName(row.reference);
  }

  toSourceIdentifiableName(row: IConditionalExpressionContent): string {
    return this.toIdentifiableName(row.reference);
  }

  toValueTypeName(row: IConditionalExpressionContent): string {
    if (row.logicalOperator !== ExpressionLogicalOperatorKinds.None) {
      return "";
    }
    if (typeof row.presentation.reference === "string") {
      return "固定値";
    }
    return this.toTypeName(row.presentation.reference);
  }

  toValueIdentifiableName(row: IConditionalExpressionContent): string {
    if (row.logicalOperator !== ExpressionLogicalOperatorKinds.None) {
      return "";
    }
    if (typeof row.presentation.reference === "string") {
      return row.presentation.reference;
    }
    return this.toIdentifiableName(row.presentation.reference);
  }

  private toTypeName(reference: IConditionalExpressionObjectReference): string {
    const object = this.toFormatObjectEditable(reference);
    return object ? object.getTypeName() : "";
  }

  private toIdentifiableName(reference: IConditionalExpressionObjectReference): string {
    const object = this.toFormatObjectEditable(reference);
    return (object && object.getIdentifiableName())
      ? object.getIdentifiableName()
      : reference.key;
  }

  private toFormatObjectEditable(row: IConditionalExpressionObjectReference): IFormatObjectEditable {
    return this.selectionObjects.find(s => {
      const linkedObject = s.toLinkedObjectIdentifier();
      return linkedObject.type === row.type &&
          linkedObject.id === row.id &&
          linkedObject.key === row.key &&
          linkedObject.subKey === row.subKey;
    });
  }

  selectionChangeContents(selection: IConditionalExpressionContent[]) {
    this.selectedContents = selection;
  }

  confirm(): void {
    const invalidMessage = this.getInvalidMessage();
    if (invalidMessage !== "") {
      this.$warn("確認結果", invalidMessage);
      return;
    }

    this.confirmed = true;
    this.isVisible = false;
  }

  private getInvalidMessage(): string {
    if (this.contents.length === 0) {
      return "条件式がありません。条件式を設定してください。";
    }
    if (this.contents[this.contents.length - 1].logicalOperator !== ExpressionLogicalOperatorKinds.None) {
      return "複合条件が設定された次の条件式がありません。複合条件の後に条件式を追加してください。";
    }
    let count = 0;
    for (const content of this.contents) {
      switch (content.operator) {
        case ExpressionOperatorKinds.LessThan:
        case ExpressionOperatorKinds.LessThanOrEqualTo:
        case ExpressionOperatorKinds.GreaterThan:
        case ExpressionOperatorKinds.GreaterThanOrEqualTo:
        case ExpressionOperatorKinds.Euqal:
        case ExpressionOperatorKinds.NotEqual:
          const num = parseFloat(content.value);
          if (isNaN(num)) {
            return "条件式の基準値は、一致・不一致の条件以外の時は数値を入力してください。";
          }
          break;
      }
      count += content.brackets.openCount - content.brackets.closeCount;
      if (content.logicalOperator === ExpressionLogicalOperatorKinds.None) {
        if (count !== 0) {
          return "条件式の括弧の数が一致しません。条件式の設定を見直してください。";
        }
      }
    }
    return "";
  }

  cancel(): void {
    this.isVisible = false;
  }
}
